import "./index.css";
import xicon from "../../assets/shapes_svg/roledetail/xicon.svg";

const Delete = ({ header, style, click, customStyle, customIconStyle }) => {
  return (
    <>
      <div
        className={
          "option__icon " + (style === "product" ? "option__icon__product" : "")
        }
        onClick={click}
        style={{ ...customStyle }}
      >
        <h5>{header}</h5>
        <img
          className={customIconStyle ? customIconStyle : "option__icon__img"}
          src={xicon}
          alt=""
        />
      </div>
    </>
  );
};

export default Delete;
